import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import {
  getEditSmsTemplateDataURL,
  getfetchSmsTemplateDataURL,
  getfetchsmsTemplateURL,
  getsmsdeleteURL,
  getsmsTemplateURL,
  getsmsUpdateURL
} from "../utils/constants/apiEndPoints";
import { commonErrMsg, smsTemplate } from "../locales/en";

const initialState = {
  loading: false,
  loadingSmsTemplateData: false
};

//  Slice
const smsTemplateLogSlice = createSlice({
  name: "smsActivityLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch
    builder
      .addCase(fetchSmsTemplateThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSmsTemplateThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchSmsTemplateThunk.rejected, (state) => {
        state.loading = false;
      })

      // Delete
      .addCase(deleteSmsTemplateThunk.rejected, (_, action) => {
        handleGenericError(action.payload);
      })

      // Toggle Status
      .addCase(toggleSmsTemplateStatusThunk.rejected, (_, action) => {
        handleGenericError(action.payload);
      })

      //toglemodal
      .addCase(smsTemplateModalThunk.rejected, (_, action) => {
        const errorResponse = action.payload;
        showToast(
          errorResponse.response?.data?.message || smsTemplate.errmsg.item2,
          showToastType.error
        );
      })

      .addCase(getfetchSmsTemplateDataThunk.pending, (state) => {
        state.loadingSmsTemplateData = true;
        state.error = null;
      })
      .addCase(getfetchSmsTemplateDataThunk.fulfilled, (state, action) => {
        state.loadingSmsTemplateData = false;
        state.templateData = action.payload.data.data;
        state.error = null;
      })
      .addCase(getfetchSmsTemplateDataThunk.rejected, (state, action) => {
        state.loadingSmsTemplateData = false;
        state.error = action.payload;
        const errorMessage =
          action.payload?.response?.data?.message || smsTemplate.errmsg.item2;
        showToast(errorMessage, showToastType.error);
      })

      .addCase(editTemplateSmsTemplateDataThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editTemplateSmsTemplateDataThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        showToast(action.payload.message, showToastType.success);
      })
      .addCase(editTemplateSmsTemplateDataThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;

        const errorMessage =
          action.payload?.response?.data?.message || smsTemplate.errmsg.item2;
        showToast(errorMessage, showToastType.error);
      });
  }
});

//  Fetch Thunk
export const fetchSmsTemplateThunk = createAsyncThunk(
  "smsTemplate/fetchSmsTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getsmsTemplateURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Delete Thunk
export const deleteSmsTemplateThunk = createAsyncThunk(
  "smsTemplate/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await privateAxios.delete(getsmsdeleteURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Toggle Status Thunk
export const toggleSmsTemplateStatusThunk = createAsyncThunk(
  "smsTemplate/toggleStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await privateAxios.patch(getsmsUpdateURL(id));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  Centralized error handler
const handleGenericError = (error) => {
  if (error?.response) {
    const status = error.response.status;
    const errors = error.response.data?.errors || [];

    if (status === 404 && !errors.every((err) => err.code === 404)) {
      showToast(errors, showToastType.error);
    } else {
      showToast(errors, showToastType.error);
    }
  } else {
    showToast(commonErrMsg.item2, showToastType.error);
  }
};

//  toggle sms modal Thunk
export const smsTemplateModalThunk = createAsyncThunk(
  "smsTemplate/smsTemplateModal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getfetchsmsTemplateURL(Number(payload))
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  get SmsTemplateData
export const getfetchSmsTemplateDataThunk = createAsyncThunk(
  "smsTemplate/getfetchSmsTemplateData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getfetchSmsTemplateDataURL(Number(payload))
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//  edit sms templateData Thunk
export const editTemplateSmsTemplateDataThunk = createAsyncThunk(
  "smsTemplate/editTemplateSmsTemplate",
  async (payload, { rejectWithValue }) => {
    const { id, data } = payload;
    try {
      const response = await privateAxios.put(
        getEditSmsTemplateDataURL(Number(id)),
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        response: error.response
      });
    }
  }
);

export default smsTemplateLogSlice.reducer;
